export const getReportCount = (state) =>
    state.report.reports.maxCount;